module.exports = __webpack_public_path__ + "static/1-0d1a10bdfbd1126575e85e4080593655.jpg";